import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.ReportsRequestPage.PopupReportScheduler', {
    title: 'Scheduler',
    buttonSave: 'Save changes',
    buttonAdd: 'Add new rule',

    newRuleName: 'New Rule',
    ruleEmailsError: 'Please enter at least one email.',
    ruleNameError: 'Please enter Rule name.',
    ruleWeekError: 'Please select at least one day of week.',
    requireError: 'Fill in the required fields',
    sameRuleError: 'One of the rules you’ve added already exists',
    ruleNameLengthError: 'Scheduling rule cannot exceed 100 characters.',

    toastUpdateSuccess: 'Scheduling rules have been successfully updated.',
    toastUpdateError: 'Scheduling rules update error.',
});
